import React, { useRef, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import Icon from 'srcReact/components/icons/Icon'
import styles from './styles.module.scss'
import { createUpdateGroupActions } from 'srcReact/GroupPage'
import Button from 'srcReact/components/common2/Button'
import Spinner from 'srcReact/components/common2/Spinner'

const PrivacySetting = ({
  show,
  nextSectionVisible,
  containerCss,
  verticalLineCss,
  infoCss,
  innerContainerCss,
  titleCss,
  buttonWrapperCss,
  editMode = false
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const containerRef = useRef(null)
  useEffect(() => {
    if (!editMode) {
      containerRef.current.scrollIntoView(true, { behavior: 'smooth' })
    }
  }, [show])

  const { privacySetting } = useSelector((state) => state.createUpdateGroup)
  const { loading, groupInfo, editSuccess } = useSelector((state) => state.createUpdateGroup)
  const [privacySettingUpdated, setPrivacySettingUpdated] = useState(false)

  useEffect(() => {
    if (editMode && editSuccess) {
      if (privacySettingUpdated) {
        setPrivacySettingUpdated(false)
      }
    }
  }, [editSuccess])

  const selectPrivacyGroup = (group) => {
    dispatch(createUpdateGroupActions.setPrivacySetting(group))
    dispatch(createUpdateGroupActions.showAdvSetting())
    dispatch(createUpdateGroupActions.setFormAsCompleted())
    setPrivacySettingUpdated(true)
  }
  const handleCancel = () => {
    dispatch(createUpdateGroupActions.setPrivacySetting(groupInfo.privacy_setting))
    dispatch(createUpdateGroupActions.showAdvSetting())
    dispatch(createUpdateGroupActions.setFormAsCompleted())
    setPrivacySettingUpdated(false)
  }
  const handleSave = () => {
    dispatch(
      createUpdateGroupActions.editGroup(groupInfo.id, {
        privacy_setting: privacySetting
      })
    )
  }

  return (
    <div
      id='privacySettingContainer'
      ref={containerRef}
      className={`${containerCss} ${!nextSectionVisible && !editMode && styles.container} ${
        show ? styles.show : styles.hide
      }`}>
      <div class={`${verticalLineCss} ${styles.verticalLine}`} />
      <p className={`${infoCss} ${styles.title1}`}>{t('group.createGroup.privacySetting.title1')}</p>

      <div className={`${innerContainerCss} ${styles.content} `}>
        <label className={titleCss}>{t('group.createGroup.privacySetting.title2')}</label>
        <div className={styles.wrapper}>
          <button
            className={`${styles.btnGroup} ${privacySetting === 'public' && styles.btnGroupSelected}`}
            onClick={() => selectPrivacyGroup('public')}>
            <div className={styles.publicIcon}>
              <Icon name='public' size='xlarge' />
            </div>
            <h2 className={styles.heading}>{t('group.createGroup.privacySetting.publicTitle')}</h2>
            <p className={styles.text}>{t('group.createGroup.privacySetting.publicText')}</p>
          </button>
          <button
            className={`${styles.btnGroup} ${privacySetting === 'private' && styles.btnGroupSelected}`}
            onClick={() => selectPrivacyGroup('private')}>
            <div className={styles.privateIcon}>
              <Icon name='private' size='xlarge' />
            </div>
            <h2 className={styles.heading}>{t('group.createGroup.privacySetting.privateTitle')}</h2>
            <p className={styles.text}>{t('group.createGroup.privacySetting.privateText')}</p>
          </button>
        </div>
      </div>
      {editMode && privacySettingUpdated && (
        <div className={buttonWrapperCss}>
          <Button style='tertiary' type='button' handleClick={handleCancel} text={t('global.cancel')} />
          <Button
            type='button'
            handleClick={handleSave}
            text={loading ? <Spinner isWhite={true} /> : t('global.save')}
          />
        </div>
      )}
    </div>
  )
}

export default PrivacySetting
